/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Use_Different_EmailInputs */

const en_password_reset_use_different_email = /** @type {(inputs: Password_Reset_Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a different email`)
};

const es_password_reset_use_different_email = /** @type {(inputs: Password_Reset_Use_Different_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar otro correo`)
};

/**
* | output |
* | --- |
* | "Use a different email" |
*
* @param {Password_Reset_Use_Different_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_use_different_email = /** @type {((inputs?: Password_Reset_Use_Different_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Use_Different_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_use_different_email(inputs)
	return en_password_reset_use_different_email(inputs)
});